import { queryOptions } from "@tanstack/react-query";

import { getDisabledModules } from "@/generated/api/farmManagement";
import { logger } from "@/shared/services/SentryLogger.service";

import {
  isFarmModule,
  toFarmModuleSettings,
  type FarmModule,
} from "./farmModules.constants";

const farmModulesKeys = {
  all: ["farm-modules"] as const,
  settings: (farmId: string) =>
    [...farmModulesKeys.all, "settings", farmId] as const,
};

const farmModulesQuery = (farmId: string) =>
  queryOptions({
    queryKey: farmModulesKeys.settings(farmId),
    queryFn: async ({ signal }) => {
      const { data } = await getDisabledModules({}, { signal });
      return toFarmModuleSettings(toKnownModules(data.disabledModules));
    },
    staleTime: Infinity,
  });

const reportedUnknownModules = new Set<string>();

const toKnownModules = (keys: readonly string[]): FarmModule[] =>
  keys.filter((key): key is FarmModule => {
    if (isFarmModule(key)) {
      return true;
    }

    if (!reportedUnknownModules.has(key)) {
      reportedUnknownModules.add(key);
      logger.warn("Unknown farm module key received from API", {
        moduleKey: key,
      });
    }

    return false;
  });

export { farmModulesQuery, farmModulesKeys };
